

const configMessageWhatsappWeb =(TIENDA,userData, pedido)=>{

    console.log("hello from message 📦 🎁 📊  ✅")
    // console.log(userData);
    // console.log(pedido);
    // console.log(TIENDA);
    var precioTotal = 0 
    var products = pedido.map((d,i)=>{

        precioTotal=precioTotal+(d.priceCurrent*d.cantidad)
        return`%0A%20%20%20%20====================%0A
        ✅producto: ${d.nameProduct.substr(0,20)}%0A
        🎁Cantidad: ${(d.cantidad)}%0A
        💵precioUnidad: ${TIENDA.country.currenciesMoneda} ${d.priceCurrent}%0A
        💰subTotal: ${TIENDA.country.currenciesMoneda} ${d.priceCurrent*d.cantidad}`
    })

    var message =`🖐️Hola%20soy%20${userData.nameClient}%0A
    hice%20este%20pedido%20en%20${TIENDA.nameNegocio}
    ${products}
    %0A%20%20%20====================%0A
    📦*Total : ${TIENDA?.country?.currenciesMoneda} ${precioTotal}*
    `

    var urlWeb = `https://web.whatsapp.com/send?phone=${TIENDA?.callingCodes}${TIENDA?.numberPhone}&text=`;
    var urlMovil =`https://api.whatsapp.com/send?phone=${TIENDA?.callingCodes}${TIENDA?.numberPhone}&text=`;
    

    if(/Windows/.test(navigator.userAgent)){
        // console.log("navegado web - laptp o pc");
        // console.log(urlWeb)
        // console.log(message.replace(/" "/gm,""))
        var messageWeb = `${urlWeb}${message.replace(/(\r\n|\n|\r)/gm,"")}`;
        window.location=messageWeb;
    }else{
        console.log('movil');
        var messageMovil = `${urlMovil}${message.replace(/(\r\n|\n|\r)/gm,"")}`;
        window.location=messageMovil;
    }
}


export default configMessageWhatsappWeb